
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"child-views\"></div>\n"
      return mustache.render(src, view, partials);
    };
  